import { Edge, XYPosition } from 'reactflow'

import { Feedback } from '../../domain/feedback'
import { HtNodeLink } from '../../domain/models/cms/hubtype/common'
import { HtContentType } from '../../domain/models/cms/hubtype/node-types'
import {
  ContentType,
  InputContentType,
  TopContentFieldsBase,
} from '../../domain/models/content-fields'
import { NodeEdges } from '../../UI/components/edges/edge-utils'
import { toSnakeCase } from '../../utils/string-utils'
import { HtSmartIntentNode } from './ht-model'

export class SmartIntentFields extends TopContentFieldsBase {
  constructor(public title: string = '', public description = '') {
    super()
  }

  contentType(): InputContentType {
    return ContentType.SMART_INTENT
  }

  stringContentType(): string {
    return 'smart intent'
  }

  static fromHubtypeCMS(component: HtSmartIntentNode): SmartIntentFields {
    const newIntent = new SmartIntentFields()
    this.setHubtypeCmsCommonData(newIntent, component)
    newIntent.title = this.formatTitle(component.content.title)
    newIntent.description = component.content.description
    return newIntent
  }

  static formatTitle(title: string): string {
    return toSnakeCase(title.toLowerCase()).replace(/^_+|_+$/g, '')
  }

  toHubtypeCMS(position: XYPosition): HtSmartIntentNode {
    const node: HtSmartIntentNode = {
      ...this.getHubtypeCmsCommonData(position),
      code: '',
      type: HtContentType.SMART_INTENT,
      content: {
        title: this.title,
        description: this.description,
      },
    }
    return node
  }

  reportErrors(feedback: Feedback, target?: HtNodeLink): boolean {
    const errors = []
    if (!this.title) errors.push('title')
    if (!this.description) errors.push('description')
    if (!target) errors.push('target')
    if (errors.length === 0) return false
    this.reportMissingFields(errors, feedback)
    return true
  }

  setErrors(): void {
    const requiredFields = []
    if (!this.title) requiredFields.push('title')
    if (!this.description) requiredFields.push('description')
    if (!this.edges.some(edge => edge.sourceHandle?.includes(this.id))) {
      requiredFields.push('target')
    }
    const fieldErrors = this.getMissingFieldsErrors(requiredFields)
    this.errors.fieldErrors = fieldErrors
  }

  hasString(value: string): boolean {
    return this.fieldsIncludeString([this.title, this.description], value)
  }

  getConnections(edges: Edge[]): NodeEdges {
    return { followUp: this.getFollowUp(edges) }
  }

  static getCopy(content: SmartIntentFields): SmartIntentFields {
    const newIntents = new SmartIntentFields()
    TopContentFieldsBase.copyContent(content, newIntents)
    return newIntents
  }
}
